module.exports = __webpack_public_path__ + "img/galet_baie_somme.6b87a7cb.jpg";